// import "../postStyle.css"; // avoid this one because page change is very slow
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import withRedux from "next-redux-wrapper";
import withReduxSaga from "next-redux-saga";
import Head from "next/head";
import PropTypes from "prop-types";
import { fetchPost, fetchRelatedPosts } from "store/posts/actions";
import Store from "store";
import { Link } from "routes";
import NProgress from "components/NProgress";
import { withStyles } from '@material-ui/core/styles';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
// import GridList from '@material-ui/core/GridList';
// import GridListTile from '@material-ui/core/GridListTile';
// import GridListTileBar from '@material-ui/core/GridListTileBar';
import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';
import TimeAgo from "react-timeago";
// import styled from 'styled-components';
// import ReactPlayer from 'react-player';
// import Axios from "/plugins/axios";
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
// import NewsItem from "../components/News/NewsItem";
import { AdSlot, DFPManager } from 'react-dfp';
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
  } from "react-device-detect";
  import Button from '@material-ui/core/Button';
import Error from './_error';
import { Comments, EmbeddedPost, EmbeddedVideo} from 'react-facebook';
// import AdSense from 'react-adsense';
import Chip from '@material-ui/core/Chip';
import TagManager from 'react-gtm-module';
import DetailImgAndVideoItem from '/components/Detail/DetailImgAndVideoItem';
import DesktopNewsItem from "/components/Desktop/DesktopNewsItem";
import ShareButtons from "/components/Detail/ShareButtons";
import MobileNewsItem from "/components/Mobile/MobileNewsItem";
import Hidden from '@material-ui/core/Hidden';
import {c} from '/utils/log'
import {getDesktopNewsItemVideoThumbnail, extractYoutubeVideoID} from '/utils/common'
import classNames from 'classnames';
import getAdSlotByDevicePosition, { getBrandAdSlotByDevicePosition } from "../utils/ads";
import BrandTeaserLogo from '/components/brandTeaserLogo';
import ContentTitle from "/components/contentTitle";
import TagChips from '/components/tagChips';
import SeoMeta from '/components/seoMeta';
import CovidGlobalStats from '/components/covidGlobalStats';
import Lazyload from 'react-lazyload';
import GalleryWidgetIframe from '/components/galleryWidgetIframe';
import AuthorAndTime from '/components/authorAndTime';
import { MobileArticleCards } from '/components/CardsSection/articleCards';
import ThereIsNoItem from '/components/thereIsNoItem';
import AuthorCards from '/components/AuthorProfile/AuthorCards';
import AuthorCard from '/components/AuthorProfile/AuthorCard';
import AuthorName from '/components/AuthorProfile/AuthorName';
import VideoWidgetIframe from '/components/videoWidgetIframe';
import ArticleDetailGraphic from '/components/Detail/ArticleDetailGraphic';
import ImgLightbox from '/components/Detail/ImgLightbox';
import {CustomScript} from 'customHooks/importScript';

// const MyStatelessComponent = props => <div>{props.name}</div>;
const styles = theme => ({
  divider:{
    backgroundColor: '#e8e3de',
    margin: '20px 0px'
  },
  root: {
      flexGrow: 1,
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden',
      padding: '0px 0px 20px',
      [theme.breakpoints.up('md')]: {
        display: 'flex'
      },
  },
  paper: {
      padding: theme.spacing.unit * 2,
      textAlign: 'center',
      color: theme.palette.text.secondary,
  },
  title: {
      color: '#fff',
      whiteSpace: 'normal',

  },

  img: {
      height: 370,
      width: '100%',
      objectFit: 'cover'
  },

  contentWrapper: {
    [theme.breakpoints.up('md')]: {
      // padding: "20px 120px",
      padding: "20px 30px",
    },
  },
  newsDetailBodyImg: {
    // fontFamily: "Arial, DuwunFont, sans-serif",
    // [theme.breakpoints.up('md')]: {
    //   padding: "20px 120px",
    // },
    "& p": {
      lineHeight: 2,
      letterSpacing: 0.2
    },
    "& img": {
      width: '80%',
      maxHeight: 800,
      objectFit: 'contain',
      backgroundColor: '#eee',
      margin: '0 auto',
      display: 'block',
      [theme.breakpoints.only('xs')]: {
          width: '100%',
      }
    },
    // "& iframe": {
    //   [theme.breakpoints.only('xs')]: {
    //     width: '100%!important',
    //   }
    // }
  },
  newsDetailBodyImgZawGyi: {
    fontFamily: "'Zawgyi-One', 'ZawgyiOne', 'serif'",
    marginTop: 30,
    // [theme.breakpoints.up('md')]: {
    //   padding: "20px 120px",
    // },
    "& p": {
      lineHeight: 2,
      letterSpacing: 0.2
    },
    "& img": {
      width: '100%',
        [theme.breakpoints.only('xs')]: {
          width: '100%',
        }
    },
  },
  inlineTeaser:{
    padding: '0px',
    // padding: '0px 20%',
    // [theme.breakpoints.only('xs')]: {
    //   padding: '0px',
    // },
    "& p": {
      lineHeight: 'initial',
    },
    "& img": {
      objectFit: 'cover'
    },
  },
  fullWidth: {
    backgroundColor: '#000',
    "& iframe": {
      [theme.breakpoints.only('xs')]: {
        width: '100%!important'
      }
    },
  },
  newsTitle:{
      fontSize: 20,
      color: 'hsla(0,0%,100%,.92)',
      lineHeight: '38px',
      display: 'inline',
      whiteSpace: 'initial',
      padding: '8px 0px',
      fontWeight: 'normal'
  },
  subtitle: {
      paddingLeft: 25
  },
  timeIcon: {
      paddingRight: 5,
      fontSize: 13,
  },
  titleWrap: {
      marginLeft: 0,
  },
  titleWrapper: {
      marginBottom: 10
  },
  // overlayColor: {
  //     position: 'absolute',
  //     top: 0,
  //     bottom: 0,
  //     left: 0,
  //     right: 0,
  //     height: '100%',
  //     width: '100%',
  //     opacity: 0.3,
  //     transition: '.5s ease',
  //     backgroundColor: '#000'
  // },
  // shadow: {
  //   '&::before': {
  //     content: '""',
  //     width: '100%',
  //     position: 'absolute',
  //     // bottom: 4,
  //     bottom: 0,
  //     left: 0,
  //     height: 150,
  //     background: 'linear-gradient(0deg,rgba(0, 0, 0, 0.63) 20%,rgba(0, 0, 0, 0.51) 40%,rgba(0, 0, 0, 0.44) 49%,transparent)'
  //   },
  // },

  author: {
      paddingLeft: 6
  },

  heading: {
      textAlign: 'center',
      fontSize: '1.5em',
      [theme.breakpoints.only('xs')]: {
        paddingLeft: 10,
        textAlign: 'left',
      },
  },
  layout: {
    [theme.breakpoints.up('md')]: {
      maxWidth: '1140px',
      width: '100%'
    },
  },
  sidebar: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      display: 'inline-block',
      width: '320px'
    },
    float : 'right',
    minHeight : '600px',
    backgroundColor : '#eee',
    overflow: 'hidden'
  },
  date: {
      marginLeft: 5
  },
  brandBadgeWrapper:{
    position: 'absolute',
    right: 12,
    top: -6,
    textAlign: 'center',
    zIndex: 1,
  },
  brandBadge: {
    background: '#fff',
    color: '#ff9803',
    borderRadius: '0px 0px 7px 7px',
    border: '1px solid #e9e9e9',
    minHeight: '28px',
    width: 68,
    display: 'inline-block',
    overflow: 'hidden'
  },
  forBefore: {
    position: 'relative',
    '&::before':{
      content: "''",
      position: 'absolute',
      borderRight: '10px solid #abacac',
      borderTop: '8px solid transparent',
      right: 80,
      top: -6,
    }
  },
  authorAndTime:{
    [theme.breakpoints.only('xs')]: {
      marginBottom: 10
    }
  },
  dot: {
    margin: '0px 7px',
    fontWeight: 'bold'
  },
  titleIcon:{
    position: 'absolute',
    fontWeight: 'bold',
    top: 5
 },
 mobileLayout:{
  padding: 14
},
});

const tagManagerArgs = {
  dataLayer: {
      userId: '001',
      userProject: 'project',
      CRMAuthor: 'CRMAuthor',
      CRMCreator: 'CRMCreator',
      Section: 'Section',
      articlePublishedDate: 'articlePublishedDate',
  }
}

// const tagManagerCampaignArgs = {
//   gtmId: 'GTM-WCJSTPT',
//   dataLayer: {
//       userId: '001',
//       userProject: 'project',
//       event: '',
//       CRMAuthor: 'CRMAuthor',
//       articlePublishedDate: 'articlePublishedDate',
//       utmCampaign: 'Undefined',
//       utmContent: 'Undefined',
//       utmMedium: 'Undefined',
//       utmSource: 'Undefined',
//       utmTerm: 'Undefined'
//   }
// }

function isFacebookApp() {
  var ua = navigator.userAgent || navigator.vendor || window.opera;
  return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
}

const countryLiteral = /_China|_France|_Germany|_Italy|_Spain|_United-Kingdom-UK|_United-States/;
// const countryLiteral = /_Australia|_Germany|_India|_Italy|_Malaysia|_Russia|_Spain|_Singapore|_Thailand|_United-Kingdom-UK|_United-States/;
const covidLiteral = /COVID|covid-19|COVID-19/;
const aseanLiteral = /_ASEAN|_Brunei|_Cambodia|_Indonesia|_Laos|_Malaysia|_Myanmar|_Philippines|_Singapore|_Thailand|_Vietnam/;
const ge2020Literal = /2020-Election|ge2020-news|ge2020-features|ge2020-voter-education/;
const careerLiteral = /အသက်မွေးဝမ်းကျောင်း_career|Jobs|Job Seeking|အလုပ်အကိုင်ရှာဖွေရေး_Job-Search/;

// const getNewCount = count => count+1
class Post extends Component {

  constructor(props){
    super(props);
    this.state = {
      isIframe: false,
      newsItems: [],
      isLoading: true,
      count: 1,
      items: [],
      ssrDone: false,
      ads: this.props.ads,
      adMobileTop:{
        id: 'div-gpt-ad-mobile-top',
        networkId: null,
        adUnit: null,
        adSizes: [[320, 100]],
        mobile: true,
        position: 'TOP',
        targetingArguments: null,
      },
      adMobileInlinePriorityOne:{
        id: 'div-gpt-ad-mobile-inline-one',
        networkId: null,
        adUnit: null,
        adSizes: [[300, 250]],
        mobile: true,
        position: 'INLINE',
        targetingArguments: null,
      },
      adMobileInlinePriorityTwo:{
        id: 'div-gpt-ad-mobile-inline-two',
        networkId: null,
        adUnit: null,
        adSizes: [[300, 250]],
        mobile: true,
        position: 'INLINE_2',
        targetingArguments: null,
      },
      adMobileMiddle:{
        id: 'div-gpt-ad-mobile-middle',
        networkId: null,
        adUnit: null,
        adSizes: [[300, 250]],
        mobile: true,
        position: 'MIDDLE',
        targetingArguments: null,
      },
      adMobileBottom:{
        id: 'div-gpt-ad-mobile-bottom',
        networkId: null,
        adUnit: null,
        adSizes: [[300, 250]],
        mobile: true,
        position: 'BOTTOM',
        targetingArguments: null,
      },

      adDesktopTop:{
        id: 'div-gpt-ad-desktop-global',
        networkId: null,
        adUnit: null,
        adSizes: [[970, 250]],
        mobile: false,
        position: 'TOP',
        targetingArguments: null,
      },
      adDesktopInlinePriorityOne:{
        id: 'div-gpt-ad-desktop-leaderboard-inline',
        networkId: null,
        adUnit: null,
        adSizes: [[728, 90]],
        mobile: false,
        position: 'INLINE',
        targetingArguments: null,
      },
      adDesktopInlinePriorityTwo:{
        id: 'div-gpt-ad-1574150161202',
        networkId: null,
        adUnit: null,
        adSizes: [[728, 90]],
        mobile: true,
        position: 'INLINE_2',
        targetingArguments: null,
      },
      adDesktopMiddle:{
        id: 'div-gpt-ad-desktop-middle',
        networkId: null,
        adUnit: null,
        adSizes: [[970, 250]],
        mobile: false,
        position: 'MIDDLE',
        targetingArguments: null,
        },
      adDesktopBottom:{
        id: 'div-gpt-ad-desktop-bottom-0',
        networkId: null,
        adUnit: null,
        adSizes: [[970, 250]],
        mobile: false,
        position: 'BOTTOM',
        targetingArguments: null,
      },

      adBrandMobileTop:{
        id: 'div-gpt-ad-brand-mobile-top',
        networkId: null,
        adUnit: null,
        adSizes: [[320, 100]],
        mobile: true,
        position: 'TOP',
        targetingArguments: null,
      },
      adBrandMobileInline:{
            id: 'div-gpt-ad-brand-mobile-inline',
            networkId: null,
            adUnit: null,
            adSizes: [[300, 250]],
            mobile: true,
            position: 'INLINE',
            targetingArguments: null,
        },
      adBrandMobileInlinePriorityOne:{
        id: 'div-gpt-ad-inline-0',
        networkId: null,
        adUnit: null,
        adSizes: [[300, 250]],
        mobile: true,
        position: 'INLINE',
        targetingArguments: null,
      },
      adBrandMobileInlinePriorityTwo:{
        id: 'div-gpt-ad-inline-0',
        networkId: null,
        adUnit: null,
        adSizes: [[300, 250]],
        mobile: true,
        position: 'INLINE_2',
        targetingArguments: null,
      },
      adBrandMobileMiddle:{
        id: 'div-gpt-ad-brand-mobile-middle',
        networkId: null,
        adUnit: null,
        adSizes: [[300, 250]],
        mobile: true,
        position: 'MIDDLE',
        targetingArguments: null,
      },
      adBrandMobileBottom:{
        id: 'div-gpt-ad-brand-mobile-bottom',
        networkId: null,
        adUnit: null,
        adSizes: [[300, 250]],
        mobile: true,
        position: 'BOTTOM',
        targetingArguments: null,
      },

      adBrandDesktopTop:{
        id: 'div-gpt-ad-brand-desktop-top',
        networkId: null,
        adUnit: null,
        adSizes: [[970, 250]],
        mobile: false,
        position: 'TOP',
        targetingArguments: null,
      },
      adBrandDesktopInline:{
        id: 'div-gpt-ad-brand-desktop-inline',
        networkId: null,
        adUnit: null,
        adSizes: [[728, 90]],
        mobile: false,
        position: 'INLINE',
        targetingArguments: null,
      },
      adBrandDesktopInlineTwo:{
        id: 'div-gpt-ad-brand-desktop-inline-two',
        networkId: null,
        adUnit: null,
        adSizes: [[728, 90]],
        mobile: false,
        position: 'INLINE_2',
        targetingArguments: null,
      },
      adBrandDesktopBottom:{
        id: 'div-gpt-ad-brand-desktop-bottom',
        networkId: null,
        adUnit: null,
        adSizes: [[970, 250]],
        mobile: false,
        position: 'BOTTOM',
        targetingArguments: null,
      },
      adBrandDesktopSidebar:{
        id: 'div-gpt-ad-brand-desktop-sidebar',
        networkId: null,
        adUnit: null,
        adSizes: [[300, 600]],
        mobile: false,
        position: 'SIDEBAR',
        targetingArguments: null,
      },
      adDesktopSidebar:{
        id: 'div-gpt-ad-desktop-sidebar',
        networkId: null,
        adUnit: null,
        adSizes: [[300, 600]],
        mobile: false,
        position: 'SIDEBAR',
        targetingArguments: null,
      },
    };
  }

  static async getInitialProps({ query, asPath, store, res, err, isServer }) {
    const { id, subCategory } = query;
    c.log(`getINitialProps of post.js ${  id}`)
    // store.dispatch(fetchPost(id));//.catch(error => c.log('Dispatch Error'));

    await store.execSagaTasks(isServer, dispatch => {
      dispatch(fetchPost(id));
    });

    c.log('getInitialProps:response')
    c.log(res)
    c.log('getInitialProps:error')
    c.log(err)

    c.log('getInitialProps:store')
    c.log(store.getState().posts)

    if(store.getState().posts.currentPost) {

      // store.dispatch(fetchCategory(subCategory));
      const currentDateTime = new Date().toISOString();
      const inlineIds = store.getState().posts.currentPost.inline ? store.getState().posts.currentPost.inline.map(item => item.id).join() : '';

      //// store.dispatch(fetchRelatedPosts(id, currentDateTime, inlineIds));
      await store.execSagaTasks(isServer, dispatch => {
        dispatch(fetchRelatedPosts(id, currentDateTime, inlineIds));
      });
      return { id, subCategory, asPath, isServer, currentDateTime};
    }
    else {
      // const statusCode = res ? res.status : err ? err.status : null;
      res.statusCode = store.getState().posts.error ? store.getState().posts.error.status : 404;
      return { id };
    }
  }

  // boxShadow= (post) => {
  //   const color = post.category.color;
  //   const categoryRoute = post.url.split('/')[1];
  //   // c.log(categoryRoute)
  //   const { classes } = this.props;
  //   const box = () => `-8px 0 0 0 ${color}, 8px 0 0 0 ${color}`
  //   const TitleStyle = styled.h1`
  //       background: ${color};
  //       box-shadow: ${box} ;

  //   `;
  //   return (
  //     <div>
  //       <GridListTileBar
  //         classes={{
  //               title: classes.title,
  //               titleWrap: classes.titleWrap,
  //               subtitle: classes.subtitle
  //           }}
  //         subtitle={
  //           <div>
  //             <TitleStyle className={classes.newsTitle}>{fontUniOrConvertZawgyi(post.title)}</TitleStyle>
  //           </div>
  //           }
  //         title={
  //           <div className="category-tag-gtm">
  //             <Link prefetch route="subCategory" params={{ category: categoryRoute, subCategory: post.category.slug }}>
  //               <a className="anchor-link">
  //                 <span
  //                   className={classes.cateStyle}
  //                   style={{
  //                           color: post.category.color
  //                       }}
  //                 >{ post.category.name }
  //                 </span>
  //               </a>
  //             </Link>
  //           </div>
  //       }
  //         titlePosition="bottom"
  //         actionPosition="left"
  //         className={classes.titleBar}
  //       />
  //     </div>
  //   )
  // }
  // loadOnTheIOScript(post) {
  //   window._io_config = {};
  //   window._io_config["0.2.0"] = [];
  //   window._io_config["0.2.0"].push({
  //     page_url: `${process.env.BACKEND_URL}${this.props.asPath}`,
  //     page_url_canonical: `${process.env.BACKEND_URL}${this.props.asPath}`.split('?')[0],
  //     page_title: post.title,
  //     page_type: "article",
  //     page_language: "my",
  //     article_authors: [post.author.name],
  //     article_categories: [this.props.url.query.subCategory],
  //     article_type: "longread",
  //     article_word_count: post.word_count ? post.word_count : 111,
  //     article_publication_date: new Date(post.published_date.date).toUTCString()
  //   });
  //   // c.log("loadOnTheIOScript");
  // }

  getDataLayerSection(post) {
    const hasCovidTags = post.tags.findIndex(item => (covidLiteral.test(item.slug))) > -1;
    if(hasCovidTags)
      return 'covid-19';
    const hasGE2020Tags = post.tags.findIndex(item => (ge2020Literal.test(item.slug))) > -1;
    if(hasGE2020Tags)
      return 'election-2020';
    return false;
  }

  render() {
    // console.log('render():post.js');
    const { post, classes, relatedPosts, isServer, ads , url, inlineTeasers } = this.props;
    const categorySlug = url.query.category;
    const subCategorySlug = url.query.subCategory;
    const {newsItems} =this.state;
    const adMobileTop = getAdSlotByDevicePosition(true, ads, this.state.adMobileTop.position);
    const adMobileInlinePriorityOne = getAdSlotByDevicePosition(true, ads, this.state.adMobileInlinePriorityOne.position);
    const adMobileInlinePriorityTwo = getAdSlotByDevicePosition(true, ads, this.state.adMobileInlinePriorityTwo.position);
    const adMobileMiddle = getAdSlotByDevicePosition(true, ads, this.state.adMobileMiddle.position);
    const adMobileBottom = getAdSlotByDevicePosition(true, ads, this.state.adMobileBottom.position);
    const adDesktopTop = getAdSlotByDevicePosition(false, ads, this.state.adDesktopTop.position);
    const adDesktopInlinePriorityOne = getAdSlotByDevicePosition(false, ads, this.state.adDesktopInlinePriorityOne.position);
    const adDesktopInlinePriorityTwo = getAdSlotByDevicePosition(false, ads, this.state.adDesktopInlinePriorityTwo.position);
    const adDesktopMiddle = getAdSlotByDevicePosition(false, ads, this.state.adDesktopMiddle.position);
    const adDesktopBottom = getAdSlotByDevicePosition(false, ads, this.state.adDesktopBottom.position);
    const adDesktopSidebar = getAdSlotByDevicePosition(false, ads, this.state.adDesktopSidebar.position,1);

    const adBrandMobileTop = getBrandAdSlotByDevicePosition(true, ads, this.state.adBrandMobileTop.position, 1);
    const adBrandMobileInlinePriorityOne = getBrandAdSlotByDevicePosition(true, ads, this.state.adBrandMobileInlinePriorityOne.position, 1);
    const adBrandMobileInlinePriorityTwo = getBrandAdSlotByDevicePosition(true, ads, this.state.adBrandMobileInlinePriorityTwo.position, 1);
    const adBrandMobileMiddle = getBrandAdSlotByDevicePosition(true, ads, this.state.adBrandMobileMiddle.position, 1);
    const adBrandMobileBottom = getBrandAdSlotByDevicePosition(true, ads, this.state.adBrandMobileBottom.position, 1);
    const adBrandDesktopTop = getBrandAdSlotByDevicePosition(false, ads, this.state.adBrandDesktopTop.position, 1);
    const adBrandDesktopInline = getBrandAdSlotByDevicePosition(false, ads, this.state.adBrandDesktopInline.position, 1);
    const adBrandDesktopInlineTwo = getBrandAdSlotByDevicePosition(false, ads, this.state.adBrandDesktopInlineTwo.position, 1);
    const adBrandDesktopBottom = getBrandAdSlotByDevicePosition(false, ads, this.state.adBrandDesktopBottom.position,1);
    const adBrandDesktopSidebar = getBrandAdSlotByDevicePosition(false, ads, this.state.adBrandDesktopSidebar.position,1);

    const ssrDone = this.state.ssrDone;
    const showAds = ads.length > 0 && ssrDone && !post.no_ads && !post.category.no_ads;
    const uniReadable = this.props.uniReadable;
    // const statusCode = post.status > 200 ? post.status : false
    const parserOptions = {
      decodeEntities: true,
      alsoParseZawGyi: false,
      preprocessNodes,
      injectedIndex: 0,
      paragraphIndex: 0,
      ssrDone: false,
      imgAdjacent: false,
      strongAdjacent: false,
      transform
    };
    const postTags = post && post.tags && post.tags.length > 0 && post.tags.map(tag => tag.name);
    const keywords = post.tags.length > 0 ? `${post.category.name},${postTags}` : `${post.category.name}`
    const forVideo = post.type === 'VIDEO' && post.video ? post.video.posters.social : 'https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/default-video-1000x500.png'
    const forVideoUrl = post.type === 'VIDEO_URL' && post.video_url ? getDesktopNewsItemVideoThumbnail(extractYoutubeVideoID(post.video_url)) : 'https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/default-video-1000x500.png'
    const forImage = post.type === 'IMAGE' &&  post.cover.social ? post.cover.social : 'https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/default-image-1000x500.png'

    const forGraphic = post.type === 'GRAPHIC' &&  post.graphic.social ? post.graphic.social : 'https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/default-image-1000x500.png'
    const ogImageURL = (
      post.type === 'VIDEO' ?  forVideo
      : post.type === 'VIDEO_URL' ?  forVideoUrl
      :  post.type === 'GRAPHIC' ? forGraphic
      : forImage
    )

    const topCovidCountryTags = post.tags.filter(item => (countryLiteral.test(item.slug)));

    const hasCovidTags = false; //post.tags.findIndex(item => (covidLiteral.test(item.slug))) > -1;
    const isCovidASEAN = hasCovidTags && post.tags.findIndex(item => (aseanLiteral.test(item.slug))) > -1;
    const hasCovidLocalTag = post.tags.findIndex(item => (/covid-19-local-news/.test(item.slug))) > -1;
    const hasGE2020Tags = post.tags.findIndex(item => (ge2020Literal.test(item.slug))) > -1;
    const hasCareerTag = post.tags.findIndex(item => (careerLiteral.test(item.slug))) > -1;

    const postRelatedAllArticle = (<Grid item xs={12}>
      <Link route={post.sponsor != null ? "brandProfile" : "category"} params={post.sponsor != null ? { brandProfile: post.sponsor.slug } : { category: categorySlug }}>
        <a className="anchor-link">
          <div className="read_all_articles">
            <Typography
              variant="body1"
              align="right"
              style={{
              color: post.sponsor != null ? "#ed731d" : post.category.color,
              cursor: 'pointer',
              textTransform: 'capitalize',
              marginBottom: 26
              }}
            >
              {`Read All Latest ${post.sponsor != null ? post.sponsor.name + "'s" : categorySlug } Articles`}
              <Icon style={{ paddingTop: 6 }}>
              keyboard_arrow_right
              </Icon>
            </Typography>
          </div>
        </a>
      </Link>
    </Grid>)

    const viewAllCOVIDStats = (<Grid item xs={12}>
      <Link route={"subCategory"} params={{ category: 'covid-19', subCategory: 'covid-19-stats' }}>
        <a className="anchor-link">
          <div className="read_all_articles">
            <Typography
              variant="body1"
              align="right"
              style={{
              color: post.sponsor != null ? "#ed731d" : post.category.color,
              cursor: 'pointer',
              textTransform: 'capitalize',
              marginBottom: 26
              }}
            >
              {`View All Latest COVID-19 Stats`}
              <Icon style={{ paddingTop: 6 }}>
              keyboard_arrow_right
              </Icon>
            </Typography>
          </div>
        </a>
      </Link>
    </Grid>)

    let breakIndex = 4;
    let breakerDetected = false;
    let injectIndexOne = 1;
    let injectIndexTwo = 3;

    function revealPartial() {
      document.getElementById("partial-wrapper").classList.remove("partial-body");
    }

    function getIndexClasses(index) {
      return "node-"+index + " para-"+parserOptions.paragraphIndex + (breakerDetected ? " partial-content" : "")
    }

    const getInjectionOne = (node, index, transform) => {
      let tagsParam = post.tags && post.tags.length > 0 ? `&tags=${post.tags.map(item => item.slug).join()}` : '';
      let categoriesParam = `&categories=${categorySlug},${subCategorySlug}`;
      let sectionPlayerId = post.category && post.category.player_id ? `&playerId=${post.category.player_id}` : '';
      let widgetPlaylistIframeURL = `/widgets/sectionVideoPlaylists?postId=${post.id}&type=latest&perPage=5${categoriesParam}${tagsParam}${sectionPlayerId}`;
      let widgetVideoIframeURL = `/widgets/videos/1000000034588616508432347804512957277787040nmp4-id1266?${sectionPlayerId}`;
      return (
        <div key={index} className={getIndexClasses(index)+" injected-"+parserOptions.injectedIndex}>
          {getChildrenOfP(node, index, transform)}
          {
            inlineTeasers && inlineTeasers.length > 0 ?
            <div className={classes.inlineTeaser}>
            <MobileArticleCards items={inlineTeasers} maxNum={2} isInlineTeaser />
            </div>
          : null
          }

          {
          !post.sponsor && //!post.category.sponsor &&
          <>
          <Lazyload
          throttle={200}
          height={200}
          offset={100}
          once
          >
          {/* <iframe className={process.env.ENVIRONMENT == "production" ? "widgetJWPlaylistIframe" : "widgetPlaylistIframe"} src="/widgets/playlists/Sjt4Unqv87?utm_campaign=article_widget&utm_content=duwun-14"></iframe> */}

          {/* For video widget */}
          {/* <VideoWidgetIframe iframeClassName="widgetVideoIframe" url={widgetVideoIframeURL}></VideoWidgetIframe>*/}

          {/* For latest videos playlist widget */}
          {/* <VideoWidgetIframe iframeClassName="widgetPlaylistIframe" url={`/widgets/sectionVideoPlaylists?type=latest&perPage=5`} /> */}

          {/* For sections videos playlist widget */}
          <VideoWidgetIframe iframeClassName="widgetPlaylistIframe" url={widgetPlaylistIframeURL} />

          {/* For playlist widget */}
          {/* <VideoWidgetIframe iframeClassName="widgetPlaylistIframe" url="/widgets/playlists/Sjt4Unqv87" /> */}
          </Lazyload>
          </>
          }
          {
          showAds &&
          <div className='ads-style'>
            {
              ssrDone && isMobile ?
                (
                  post.sponsor != null ?
                    adBrandMobileInlinePriorityOne.id &&
                    <AdSlot
                      sizes={adBrandMobileInlinePriorityOne.adSizes}
                      dfpNetworkId={adBrandMobileInlinePriorityOne.networkId}
                      adUnit={adBrandMobileInlinePriorityOne.adUnit}
                      shouldRefresh={()=> true}
                    />
                  :
                    adMobileInlinePriorityOne.id &&
                    <AdSlot
                     sizes={adMobileInlinePriorityOne.adSizes}
                     dfpNetworkId={adMobileInlinePriorityOne.networkId}
                     adUnit={adMobileInlinePriorityOne.adUnit}
                     shouldRefresh={()=> true}
                     slotId={this.state.adMobileInlinePriorityOne.id}
                    />
                ) : null
            }
            {
              ssrDone && isBrowser ?
                (
                  post.sponsor != null ?
                    adBrandDesktopInline.id && adBrandDesktopInline.networkId &&
                    <AdSlot
                      sizes={adBrandDesktopInline.adSizes}
                      dfpNetworkId={adBrandDesktopInline.networkId}
                      adUnit={adBrandDesktopInline.adUnit}
                      shouldRefresh={()=> true}
                      slotId={adBrandDesktopInline.id}
                    />
                  :
                    adDesktopInlinePriorityOne.id &&
                    <AdSlot
                      sizes={adDesktopInlinePriorityOne.adSizes}
                      dfpNetworkId={adDesktopInlinePriorityOne.networkId}
                      adUnit={adDesktopInlinePriorityOne.adUnit}
                      shouldRefresh={()=> true}
                      slotId={this.state.adDesktopInlinePriorityOne.id}
                    />
                ) : null
            }
          </div>
          }
          {
            // ssrDone && showAds && isMobile && process.env.ENVIRONMENT !== "production" &&
            // <div style={{ textAlign : 'center' }}>
            //   <AdSlot
            //     sizes={[[300, 250]]}
            //     dfpNetworkId="73195129"
            //     adUnit="teads_ad_test"
            //     targetingArguments={{ env: 'staging' }}
            //     shouldRefresh={()=> true}
            //     slotId="teads_ad_test"
            //   />
            // </div>
          }
        </div>
      );
    }

    const getInjectionTwo = (node, index, transform) => {
      return (
        <div key={index} className={getIndexClasses(index)+" injected-"+parserOptions.injectedIndex}>
          {getChildrenOfP(node, index, transform)}
          {/* <div class="widgetVideoWrapper">
            <iframe class="widgetVideoIframe" src="/widgets/videos/d-gogoeateat-mp4-id398" width="100%" height="auto"></iframe>
          </div> */}
          {/* <iframe className="widgetVideoIframe" src="/widgets/playlists/4vouSWrQ5g" ></iframe> */}
          {
          showAds &&
          <div className='ads-style'>
            {/* <Lazyload height={250} offset={100} once> */}
            {
              ssrDone && isMobile ?
              (
                post.sponsor != null ?
                  adBrandMobileInlinePriorityTwo.id &&
                  <AdSlot
                    sizes={adBrandMobileInlinePriorityTwo.adSizes}
                    dfpNetworkId={adBrandMobileInlinePriorityTwo.networkId}
                    adUnit={adBrandMobileInlinePriorityTwo.adUnit}
                    shouldRefresh={()=> true}
                  />
                :
                  adMobileInlinePriorityTwo.id &&
                  <AdSlot
                    sizes={adMobileInlinePriorityTwo.adSizes}
                    dfpNetworkId={adMobileInlinePriorityTwo.networkId}
                    adUnit={adMobileInlinePriorityTwo.adUnit}
                    shouldRefresh={()=> true}
                    slotId={this.state.adMobileInlinePriorityTwo.id}
                  />
              ) : null
            }
            {
              ssrDone && isBrowser ?
              (
                post.sponsor != null ?
                  adBrandDesktopInlineTwo && adBrandDesktopInlineTwo.networkId &&
                  <AdSlot
                    sizes={adBrandDesktopInlineTwo.adSizes}
                    dfpNetworkId={adBrandDesktopInlineTwo.networkId}
                    adUnit={adBrandDesktopInlineTwo.adUnit}
                    shouldRefresh={()=> true}
                    slotId={adBrandDesktopInlineTwo.id}
                  />
                :
                  adDesktopInlinePriorityTwo.id &&
                  <AdSlot
                    sizes={adDesktopInlinePriorityTwo.adSizes}
                    dfpNetworkId={adDesktopInlinePriorityTwo.networkId}
                    adUnit={adDesktopInlinePriorityTwo.adUnit}
                    shouldRefresh={()=> true}
                    slotId={this.state.adDesktopInlinePriorityTwo.id}
                  />
              ) : null
            }
            {/* </Lazyload> */}
          </div>
          }
          {
          categorySlug === 'careers' ? ssrDone && (process.env.ENVIRONMENT !== "production" || hasCareerTag) &&
            <Lazyload
              throttle={200}
              height={200}
              offset={100}
              once
            >
              <GalleryWidgetIframe url="/widgets/galleries/LbN6rhAMcu/singleSlide"/>
            </Lazyload>
            :  ssrDone && (process.env.ENVIRONMENT !== "production" || hasGE2020Tags) &&
              <Lazyload
                throttle={200}
                height={200}
                offset={100}
                once
              >
                <GalleryWidgetIframe url="/widgets/galleries/jBmvyC9FDs/singleSlide"/>
              </Lazyload>
          }
        </div>
      );
    }
    let imgArr = []
    post.cover && post.cover.teaser && imgArr.unshift(post.cover.teaser)
    function getAllChildren(node, index, transform) {
      let imgChildren = node.children && node.children.filter(child => child.type == 'tag' && child.name == 'img');
      if (imgChildren && imgChildren.length > 0)  {
        let imgSrc = imgChildren[0].attribs.src;
        imgArr.push(imgSrc)
      }
      return (
        node.children.map((child, index) => {
         return (
          (child.type == 'tag' && child.name == 'img') ? (
          <Lazyload key={index} height={200} offset={300} once>
            <ImgLightbox imgProps={convertNodeToElement(child, index, transform)} imgArr={imgArr} />
          </Lazyload>
          ) :
          convertNodeToElement(child, index, transform)
        )})
      )
    }

    function getChildrenOfP(node, index, transform) {
      return (
        node.name == 'blockquote' ?
        <blockquote key={index} className={getIndexClasses(index)}>
          {getAllChildren(node, index, transform)}
        </blockquote> :
        <p key={index} className={getIndexClasses(index)}>
          {getAllChildren(node, index, transform)}
        </p>
      );
    }

    function injectOrProceed(node, index, transform) {
      if (parserOptions.paragraphIndex === injectIndexOne) {
        injectIndexOne = 1000;
        if(!breakerDetected)
          breakIndex++;
        parserOptions.injectedIndex++;
        return getInjectionOne(node, index, transform);
      }
      if (parserOptions.paragraphIndex === injectIndexTwo) {
        injectIndexTwo = 1000;
        if(!breakerDetected)
          breakIndex++;
        parserOptions.injectedIndex++;
        return getInjectionTwo(node, index, transform);
      }

      return getChildrenOfP(node, index, transform);
    }

    function breakOrProceed(node, index, transform) {
      parserOptions.paragraphIndex++;

      if (parserOptions.paragraphIndex == breakIndex && !breakerDetected) {
        let breakIndexClasses = getIndexClasses(index) + " break-"+breakIndex;
        breakerDetected = true;
        return (
          <div key={index} className={breakIndexClasses}>
          {convertNodeToElement(node, index, transform)}
          {
            // parserOptions.paragraphIndex == 4 &&
            <div className={classNames("partial-breaker", 'read_more_btn_gtm')}>
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={() => revealPartial()}
              >
                <span>
                  {
                      uniReadable ? 'ဆက်ဖတ်ရန်' : 'Read More'
                  }
                </span>
              </Button>
            </div>
          }
          </div>
        );
      }
      return injectOrProceed(node, index, transform);
    }

    /*
    * The transform function will be called for every node that is parsed by the library.
    * Ref: https://www.npmjs.com/package/react-html-parser
    */
    function transform(node, index) {

      if (node.type === 'tag' && node.name === 'div' && node.attribs && node.attribs.class === "fb-post fb-video") {
        // c.log(node);
        // should not render if href is empty or invalid video url (e.g data-href="true" is invalid)
        if(node.attribs["data-href"].length > 5)
        return (
          <div key={index} className={getIndexClasses(index)}>
            <EmbeddedVideo href={node.attribs["data-href"]} width={node.attribs["data-width"]} />
          </div>
        );
        // return <div>fb widget found !!</div>;
      }

      if (node.type === 'tag' && (node.name === 'p' || node.name === 'blockquote')){

        let imgChildren = node.children && node.children.filter(child => child.type == 'tag' && child.name == 'img');

        if (imgChildren && imgChildren.length > 0) {// && imgChildren[0].attribs.class === "img-fluid") {
          parserOptions.imgAdjacent = true;
          return (
            <div key={index} className={getIndexClasses(index)}>
             {
              getAllChildren(node, index, transform)
              // imgChildren.map((child, index) => (
              // <Lazyload key={index} height={200} offset={300} once>
              //   <ImgLightbox imgProps={convertNodeToElement(child, index, transform)} />
              // </Lazyload>
              // ))
             }
            </div>
          );
        }

        // strong or br tags inside p tag will not be counted as Paragraph (injectedIndex)
        if (node.children && node.children.length > 0 && node.children[0].type === 'tag'
        && (node.children[0].name === 'br'
        || node.children[0].name === 'strong'
        || (node.children[0].data && node.children[0].data.length <= 120))
        ) {
          parserOptions.strongAdjacent = true;
          return getChildrenOfP(node, index, transform);
        }

        // console.log('node.children: ',node.children);
        // if(node.children && !node.children[0].attribs)

        if (parserOptions.imgAdjacent || parserOptions.strongAdjacent) {
          parserOptions.imgAdjacent = false;
          parserOptions.strongAdjacent = false;
          if(parserOptions.paragraphIndex <= breakIndex && !breakerDetected)
            breakIndex++;
          // injectIndexOne++;
          // injectIndexTwo++;
          //return breakOrProceed(node, index, transform);
          // return (
          //   <div key={index} className={getIndexClasses(index)}>
          //     {convertNodeToElement(node, index, transform)}
          //   </div>
          // );
        }

        return breakOrProceed(node, index, transform);
      } // end of node.name == 'p'

      if (node.type === 'tag' && node.name === 'iframe' && node.attribs
      && (node.attribs.class === "fb-widget" || node.attribs.class === "ql-video")
      ) {
        // c.log("node.attribs");
        // c.log(node.attribs);
        if(node.attribs.allowtransparency)
          delete node.attribs.allowtransparency;

        // node.attribs.splice( node.attribs.indexOf('allowtransparency'), 1 );
        // let newAttribs = node.attribs.filter( a => a !== "allowtransparency" );
        return (
          <div key={index} className={getIndexClasses(index)}>
            <Lazyload key={index} height={200} offset={300} once>
            {convertNodeToElement(node, index, transform)}
            </Lazyload>
          </div>
        );
      }

      if(node.attribs)
        node.attribs.class = node.attribs.class ? node.attribs.class + ' ' + getIndexClasses(index) : getIndexClasses(index);

      return (
        convertNodeToElement(node, index, transform)
      );
    }

    /*
     * Allows pre-processing the nodes generated from the html by htmlparser2 before being passed to the library and converted to React elements.
     * Ref: https://www.npmjs.com/package/react-html-parser
     */
    function preprocessNodes(nodes) {
      // c.log(nodes);
      // c.log(parserOptions.alsoParseZawGyi);
      let validPNodes = nodes.filter(node => (node.name == 'p' || node.name == 'blockquote')
        && node.children && node.children.length > 0 && !node.children[0].attribs
        && node.children[0].data && node.children[0].data.length > 120
      );
      // console.log('validPNodes.length:', validPNodes.length);
      if(validPNodes.length < 7)
        breakIndex = 1000;

      if(parserOptions.alsoParseZawGyi){
        return nodes.filter( function recursiveFunction(o) {
          if (o.children && o.children.length) {
            // c.log(o.children);
            return (o.children = o.children.filter(recursiveFunction)).length
          }
          else if (o.type === 'tag'){
            if (o.name == 'img') {
              return false;
            }
            else if (o.name === 'div' && o.attribs.class === "fb-post fb-video") {
              return false;
            }
            else if (o.name === 'iframe' && o.attribs.class === "ql-video") {
              return false;
            }
          }
          return true;
        });
      }
      parserOptions.alsoParseZawGyi = true;
      return nodes;
    }

    parserOptions.ssrDone = ssrDone;
    const unicodeContent = post.body && (ReactHtmlParser(`${post.body}`, parserOptions))
    const zawgyiContent = post.body && !uniReadable && (ReactHtmlParser(fontUniOrConvertZawgyi(`${post.body}`), parserOptions))

    let currentDate = new Date().toISOString();
    let dateCondition = post.published_date.date > currentDate;
    // console.log('ggg')
    // console.log('approve ' + post.is_approved)
    // console.log('is_draft ' + post.is_draft)
    // console.log('dateCondition ' + dateCondition)
    let sidebarContent = () => {
      return(
        !isMobile && ssrDone &&
        <div style={{ display: post.no_ads && post.no_ads == true ? 'none' : ''}} className={classes.sidebar}>
        {
          post.sponsor != null ?
          ssrDone && showAds && isBrowser &&
          <div style={{ textAlign : 'center', padding: '11px', marginBottom: '10px' }}>
            <AdSlot
              sizes={adBrandMobileInlinePriorityOne.adSizes}
              dfpNetworkId={adBrandMobileInlinePriorityOne.networkId}
              adUnit={adBrandMobileInlinePriorityOne.adUnit}
              shouldRefresh={()=> true}
            />
          </div>
          :
          ssrDone && showAds && isBrowser &&
          <div style={{ textAlign : 'center', padding: '11px', marginBottom: '10px' }}>
            <AdSlot
              sizes={adMobileInlinePriorityOne.adSizes}
              dfpNetworkId={adMobileInlinePriorityOne.networkId}
              adUnit={adMobileInlinePriorityOne.adUnit}
              shouldRefresh={()=> true}
              slotId={this.state.adMobileInlinePriorityOne.id}
            />
          </div>
        }
        {
          post.sponsor || post.category.sponsor ?
            adBrandDesktopSidebar.networkId &&
            <div style={{ textAlign : 'center'}}>
              <AdSlot
                sizes={adBrandDesktopSidebar.adSizes}
                dfpNetworkId={adBrandDesktopSidebar.networkId}
                adUnit={adBrandDesktopSidebar.adUnit}
                shouldRefresh={()=> true}
                slotId={this.state.adBrandDesktopSidebar.id}
              />
            </div>
            :
            adDesktopSidebar.networkId ?
            <div style={{ textAlign : 'center'}}>
              <AdSlot
                sizes={adDesktopSidebar.adSizes}
                dfpNetworkId={adDesktopSidebar.networkId}
                adUnit={adDesktopSidebar.adUnit}
                shouldRefresh={()=> true}
                slotId={this.state.adDesktopSidebar.id}
              />
            </div>
            :
            <Lazyload height={250} offset={100} once>
              <CovidGlobalStats ssrDone={ssrDone} type={"mohs"} width={300} />
            </Lazyload>
        }
        {
          ssrDone && showAds && isBrowser && categorySlug === 'careers' &&
          <div style={{ textAlign : 'center', padding: '11px', margin: '10px  0px' }}>
            <AdSlot
              dfpNetworkId="73195129"
              sizes={[[300, 250]]}
              adUnit="duwun_mobile_sidebar_priority_2"
              targetingArguments={{ section: 'careers' }}
              shouldRefresh={() => true}
              slotId="duwun_mobile_sidebar_priority_2"
            />
          </div>
        }
        </div>
      )
    }
    if(post.is_draft === true && post.is_approved === false && !this.state.isIframe ){
      // use post.is_approved === false instead of !post.is_approved because post.is_approved is undefined in cms
      return(
        <ThereIsNoItem thereIsNoItem="This article is draft." />
      )
    }else  if(post.is_approved === false && !this.state.isIframe){
      return(
        <ThereIsNoItem thereIsNoItem="This article hasn't been approved." />
      )
    }else if(dateCondition && !this.state.isIframe){
      return(
        <ThereIsNoItem thereIsNoItem="This article hasn't been published." />
      )
    } else{
    return (
      <div>
        <Head>
          {post && <title>{fontUniOrConvertZawgyi(post.title)}</title>}
          {/* <script async src="https://cdn.onthe.io/io.js/mAtIkilNLLPJ"></script>   */}
          <link rel="stylesheet" href="/static/css/postDetailStyle.css" />
        </Head>
        <CustomScript src="https://adxbid.info/duwun.js" />
        <SeoMeta
            url={`${process.env.BACKEND_URL}${this.props.asPath}`}
            type="article"
            title={fontUniOrConvertZawgyi(post.title)}
            description={fontUniOrConvertZawgyi(post.description)}
            image={ogImageURL}
            themeColor={post.category.color}
            section={post.category.name}
            keywords={keywords}
            pubDate={post.published_date.date}
            lastMod={post.updated_at.date}
          />
        <NProgress />
        {
          showAds && ssrDone && isMobile &&
            (
              post.sponsor != null ?
                adBrandMobileTop.id &&
                <div className='ads-global-style'>
                  <AdSlot
                    sizes={adBrandMobileTop.adSizes}
                    dfpNetworkId={adBrandMobileTop.networkId}
                    adUnit={adBrandMobileTop.adUnit}
                    shouldRefresh={() => true}
                  />
                </div>
              :
                adMobileTop.id &&
                <div className='ads-global-style'>
                  <AdSlot
                    sizes={adMobileTop.adSizes}
                    dfpNetworkId={adMobileTop.networkId}
                    adUnit={adMobileTop.adUnit}
                    shouldRefresh={() => true}
                    slotId={this.state.adMobileTop.id}
                  />
                </div>
            )
        }
        {
          showAds && ssrDone && isBrowser &&
            (
              <Hidden smDown>
              {
              post.sponsor != null ?
                adBrandDesktopTop.id &&
                <div className='ads-global-style'>
                  <AdSlot
                    sizes={adBrandDesktopTop.adSizes}
                    dfpNetworkId={adBrandDesktopTop.networkId}
                    adUnit={adBrandDesktopTop.adUnit}
                    shouldRefresh={()=> true}
                  />
                </div>
              :
                adDesktopTop.id &&
                <div className='ads-global-style'>
                  <AdSlot
                    sizes={adDesktopTop.adSizes}
                    dfpNetworkId={adDesktopTop.networkId}
                    adUnit={adDesktopTop.adUnit}
                    shouldRefresh={()=> true}
                    slotId={this.state.adDesktopTop.id}
                  />
                </div>
              }
              </Hidden>
            )
        }
        <div className={classes.root}>
          <div className={classes.layout}>
          {post && (
            <div data-io-article-url={process.env.BACKEND_URL+this.props.asPath} key={post.slug}>
              {/* {post.sponsor != null? <div className={classes.forBefore}>
                <div className={classes.brandBadgeWrapper}>
                  <div className={classes.brandBadge}>
                    <Link prefetch route="brandProfile" params={{ brandProfile: post.sponsor.slug }}>
                      <a className="anchor-link">
                        <img src={post.sponsor.logo} style={{width: '68px', height: 'auto', verticalAlign: 'middle'}} alt="" />
                      </a>
                    </Link>
                  </div>
                </div>

              </div>: null} */}

              {post.type === 'GRAPHIC' ?
                <Grid
                container
                direction="row"
                justify="space-between"
              >
                  <ArticleDetailGraphic item={post} isServer={isServer} url={url} />
                  {sidebarContent()}
                </Grid>
                :
                <DetailImgAndVideoItem item={post} isServer={isServer} url={url} video={post.video} />
              }
              <Grid container>
                <Grid item xs={12}>
                  <CardContent style={{backgroundColor: '#fff'}}>
                    {post.description != null &&
                    <Typography component="div" className={classes.newsDetailBodyImg} style={{marginBottom: 5, fontWeight: 'bold'}}>
                      {fontUniOrConvertZawgyi(`${post.description}`)}
                    </Typography>
                    }
                    <Grid container justify="space-between">
                      {
                        post.type === 'IMAGE' || post.type === 'GRAPHIC' ?
                          <AuthorAndTime item={post} linkColor="rgba(0, 0, 0, 0.8705882352941177)" />
                        : null
                      }

                      {post.sponsor != null ?
                        <div style={{display: 'flex'}}>
                          <Typography variant="caption" className={classes.authorAndTime} style={{marginRight: 8}}>
                            Sponsored by
                          </Typography>
                          <BrandTeaserLogo brandTeaserLogo={post.sponsor.logo} brandSlug={post.sponsor.slug} />
                        </div>
                        : null}
                    </Grid>
                    <Grid container>
                      {
                        post.co_authors && post.co_authors.length > 0 &&
                        <Typography style={{ fontSize: '0.75rem' }}>
                         {`Co-Authors: `}
                        {
                          post.co_authors.map((item, index) => (
                            <React.Fragment key={index} >
                              <AuthorName item={item} linkColor="rgba(0, 0, 0, 0.8705882352941177)" />
                              {
                                post.co_authors.length === index + 1 ? null : ", "
                              }
                            </React.Fragment>
                          ))
                        }
                      </Typography>
                      }
                    </Grid>
                    {
                      post.type === 'IMAGE' && sidebarContent()
                    }

                    {
                      ssrDone && showAds && process.env.ENVIRONMENT !== "production" &&
                      <div style={{ textAlign : 'center', width:'1px', height:'1px', overflow:'hidden' }}>
                        <AdSlot
                          sizes={[[1, 1]]}
                          dfpNetworkId="73195129"
                          adUnit="teads_ad_1x1"
                          targetingArguments={{ env: 'staging' }}
                          shouldRefresh={()=> true}
                          slotId="teads_ad_1x1"
                        />
                      </div>
                    }

                    {/* {
                    !isMobile && ssrDone &&
                    <div className={classes.sidebar}>
                    {
                      ssrDone && showAds && isBrowser && process.env.ENVIRONMENT !== "production" &&
                      <div style={{ textAlign : 'center' }}>
                        <AdSlot
                          sizes={[[1, 1]]}
                          dfpNetworkId="73195129"
                          adUnit="teads_ad_1x1"
                          targetingArguments={{ env: 'staging' }}
                          shouldRefresh={()=> true}
                        />
                      </div>
                    }
                    {
                      post.sponsor || post.category.sponsor ?
                        adBrandDesktopSidebar.networkId &&
                        <div style={{ textAlign : 'center'}}>
                        <AdSlot
                          sizes={adBrandDesktopSidebar.adSizes}
                          dfpNetworkId={adBrandDesktopSidebar.networkId}
                          adUnit={adBrandDesktopSidebar.adUnit}
                          shouldRefresh={()=> false}
                          slotId={adBrandDesktopSidebar.id}
                        />
                        </div>
                        :
                        adDesktopSidebar.networkId ?
                        <div style={{ textAlign : 'center'}}>
                        <AdSlot
                          sizes={adDesktopSidebar.adSizes}
                          dfpNetworkId={adDesktopSidebar.networkId}
                          adUnit={adDesktopSidebar.adUnit}
                          shouldRefresh={()=> false}
                          slotId={adDesktopSidebar.id}
                        />
                        </div>
                        :
                        <CovidGlobalStats ssrDone={ssrDone} type={"mohs"} width={300} />
                    }
                    </div>
                    } */}
                    <div className={classes.contentWrapper}>
                      <div id="partial-wrapper" className={"total-para-"+parserOptions.paragraphIndex + " " + (breakerDetected ? "partial-body break-at-"+breakIndex : "content-body")}>
                      {uniReadable &&
                      <Typography style={{ maxWidth : '730px', position : 'relative' }} component="div" className={classes.newsDetailBodyImg}>
                        {
                          // <strong>[Unicode Version]</strong>
                        }
                        {/* { ReactHtmlParser(`${post.body}`, parserOptions) } */}
                        {unicodeContent}
                      </Typography>
                      }
                      {
                      !uniReadable &&
                      <Typography component="div" className={classes.newsDetailBodyImgZawGyi}>
                        <strong>[Zawgyi Version]</strong>
                        {/* { ReactHtmlParser(fontUniOrConvertZawgyi(`${post.body}`), parserOptions) } */}
                        {zawgyiContent}
                      </Typography>
                      }
                      </div>

                      {
                      showAds && ssrDone && isMobile &&
                      ( post.sponsor != null ?
                          adBrandMobileMiddle.id &&
                          <div className='ads-style'>
                            <Lazyload height={250} offset={300} once>
                              <AdSlot
                                  sizes={adBrandMobileMiddle.adSizes}
                                  dfpNetworkId={adBrandMobileMiddle.networkId}
                                  adUnit={adBrandMobileMiddle.adUnit}
                                  shouldRefresh={()=> true}
                              />
                            </Lazyload>
                          </div>
                        :
                          adMobileMiddle.id &&
                          <div className='ads-style'>
                            {/* <Lazyload height={250} offset={300} once> */}
                              <AdSlot
                                  sizes={adMobileMiddle.adSizes}
                                  dfpNetworkId={adMobileMiddle.networkId}
                                  adUnit={adMobileMiddle.adUnit}
                                  shouldRefresh={()=> true}
                                  slotId={this.state.adMobileMiddle.id}
                              />
                            {/* </Lazyload> */}
                          </div>
                      )
                      }
                      {
                        showAds && ssrDone && isBrowser &&
                        (
                          <Hidden smDown>
                            <Lazyload height={250} offset={300} once>
                            {
                              adDesktopTop.id &&
                                <div className='ads-style'>
                                  <AdSlot
                                    sizes={adDesktopMiddle.adSizes}
                                    dfpNetworkId={adDesktopMiddle.networkId}
                                    adUnit={adDesktopMiddle.adUnit}
                                    shouldRefresh={()=> true}
                                    slotId={this.state.adDesktopMiddle.id}
                                  />
                                </div>
                            }
                            </Lazyload>
                          </Hidden>
                        )
                      }

                      <div className='onesignal-customlink-container'></div>
                      {/* {
                      ssrDone && hasGE2020Tags &&
                      <Lazyload
                      throttle={200}
                      height={200}
                      offset={100}
                      once
                      >
                        <iframe width="100%" height="250" style={{border:'none'}} className="electionCountDownIframe" src="https://duwun-data.sgp1.cdn.digitaloceanspaces.com/ads/election_2020.html" ></iframe>
                      </Lazyload>
                      } */}
                      <TagChips tagChips={post.tags} />
                      {
                        hasCovidTags && topCovidCountryTags && topCovidCountryTags.map((tag, index) => (
                          <CovidGlobalStats key={index} ssrDone={ssrDone} type={tag.slug} />
                        ))
                      }
                      {
                      // showAds && ssrDone && isMobile && hasCovidLocalTag &&
                      // adMobileMiddle.id &&
                      // <div style={{ textAlign : 'center' }}>
                      //   <Lazyload height={250} offset={300} once>
                      //     <AdSlot
                      //         sizes={adMobileMiddle.adSizes}
                      //         dfpNetworkId={adMobileMiddle.networkId}
                      //         adUnit={"duwun_desktop_new_template_global_rectangle_300x250"}
                      //         targetingArguments={adMobileMiddle.targetingArguments}
                      //         shouldRefresh={()=> false}
                      //         // slotId={adMobileMiddle.id}
                      //     /><br />
                      //   </Lazyload>
                      // </div>
                      // <CovidGlobalStats ssrDone={ssrDone} type={"mindmap"} />
                      }
                      {
                      (hasCovidTags || hasCovidLocalTag) &&
                      <Lazyload height={250} offset={300} once>
                        {hasCovidLocalTag ?
                        <CovidGlobalStats ssrDone={ssrDone} type={"geo"} />
                        :
                        <CovidGlobalStats ssrDone={ssrDone} type={isCovidASEAN ? "asean" : "all"} />
                        }
                        {viewAllCOVIDStats}
                      </Lazyload>
                      }
                      <ShareButtons url={url} item={post} />
                      <Divider className={classes.divider} />

                      {/* Authors and co-authors*/}
                      <Typography component="h3" style={{ fontSize: '1.17em', margin: '2em 0px 0px' }} gutterBottom>
                      {post.co_authors && post.co_authors.length > 0 ? 'Authors' : 'Author'}
                      </Typography>
                      <Grid container>
                        <AuthorCard item={post.author} />
                        {
                          post.co_authors && <AuthorCards items={post.co_authors} />
                        }
                      </Grid>

                      {/* Contributors */}
                      {
                        post.contributors && post.contributors.length > 0 &&
                        <>
                          <Typography component="h3" style={{ fontSize: '1.17em', margin: '2em 0px 0px' }} gutterBottom>
                          {post.contributors.length == 1 ? 'Contributor' : 'Contributors'}
                          </Typography>
                          <Grid container>
                            <AuthorCards items={post.contributors} />
                          </Grid>
                        </>
                      }

                      <Divider className={classes.divider} />

                      <div className="fbCommentWrapper">
                        <Comments href={`${process.env.BACKEND_URL}${this.props.asPath}`} />
                      </div>
                    </div>
                  </CardContent>
                </Grid>
              </Grid>
            </div>
            )
          }
          {/* *************** desktop View ****************** */}
          <Hidden only={['sm', 'xs', 'md']}>
            <Grid container>
              <ContentTitle contentTitle="Suggested" color="#ed7123" />
              {relatedPosts && relatedPosts.length > 0 && relatedPosts.map((post, index) => (
                <Grid item xs={3} key={index}>
                  <DesktopNewsItem item={post} className="related-post-gtm" />
                </Grid>
                ))}
              {postRelatedAllArticle}
            </Grid>
          </Hidden>
          {/* *************** mobile View ****************** */}
          <Hidden only={['lg', 'xl']}>
            {/* <MobileView> */}
            <Grid container className='mobileLayout' >
              <Grid item xs={12}>
                {relatedPosts && relatedPosts.length > 0 ?
                <div>
                  <ContentTitle contentTitle="Suggested" color="#ed7123" />

                  {relatedPosts && relatedPosts.length > 0 && relatedPosts.map((post, index) => (
                    index < 3 ?
                      <MobileNewsItem key={index} item={post} className="related-post-gtm" />
                    : null
                  ))}
                </div>
                : null}
              </Grid>
              {postRelatedAllArticle}
            </Grid>
            {/* </MobileView> */}
          </Hidden>
          {
          showAds && isMobile && ssrDone &&
          (
            post.sponsor != null ?
              adBrandMobileBottom.id &&
              <div className='ads-style'>
                <AdSlot
                  sizes={adBrandMobileBottom.adSizes}
                  dfpNetworkId={adBrandMobileBottom.networkId}
                  adUnit={adBrandMobileBottom.adUnit}
                  shouldRefresh={()=> true}
                  // slotId={adBrandMobileBottom.id}
                />
              </div>
            :
              adMobileBottom.id &&
              <div className='ads-style'>
                <AdSlot
                  sizes={adMobileBottom.adSizes}
                  dfpNetworkId={adMobileBottom.networkId}
                  adUnit={adMobileBottom.adUnit}
                  shouldRefresh={()=> true}
                  slotId={this.state.adMobileBottom.id}
                />
              </div>
          )
          }
          {
          showAds && isBrowser ?
          (
            <Hidden smDown>
            {
            ssrDone && post.sponsor != null ?
              adBrandDesktopBottom.id &&
              <div className='ads-style'>
                <AdSlot
                  sizes={adBrandDesktopBottom.adSizes}
                  dfpNetworkId={adBrandDesktopBottom.networkId}
                  adUnit={adBrandDesktopBottom.adUnit}
                  shouldRefresh={()=> true}
                />
              </div>
            :
              adDesktopBottom.id &&
              <div className='ads-style'>
                <AdSlot
                  sizes={adDesktopBottom.adSizes}
                  dfpNetworkId={adDesktopBottom.networkId}
                  adUnit={adDesktopBottom.adUnit}
                  shouldRefresh={()=> true}
                  slotId={this.state.adDesktopBottom.id}
                />
              </div>
            }
            </Hidden>
          ) : null
          }

          {/* Duwun's adsense responsive and native ads
          <AdSense.Google
            client='ca-pub-5143846535014081'
            slot='6280675385'
            style={{ display: 'block', textAlign: 'center' }}
            layout='in-article'
            format='fluid'
          />          */}

          {/* {newsItems && newsItems.map((newsItem, index) => (
            // for style use React.Fragment instead <div>
            <React.Fragment key={newsItem.slug} >
              <NewsItem key={newsItem.slug} item={newsItem} />
              {index > 0 && ((index+1) % 5) === 0 ? this.__getDfpAds(Math.floor(index / 5)) : null }
            </React.Fragment>
          ))}   */}
          {/* {this.__nextBtn ()} */}

          </div>
        </div>
        {/* <Footer categoryItems={categories} /> */}

      </div>
    );
  }
  }

  componentDidMount () {
    const { isServer, post } = this.props;
    c.log(`post.js:componentDidMount():isServer:${isServer}`);

    window.noGlobalAds = post.no_ads || (post.category && post.category.no_global_ads);

    // const { post } = this.props;
    window.DFPManagerLoaded = false;
    this.setState({
        ssrDone: true,
        // next: post.related_posts.data.links.next
        // next: this.props.links.next
    });
    // tagManagerArgs.dataLayer.CRMAuthor = post.author.name
    // TagManager.dataLayer(tagManagerArgs)
    // initCovidWidgets();
    if( window.location !== window.parent.location){
      this.setState({ isIframe: true }) //The page is in an iframe
     }
  }

  componentDidUpdate(previousProps, previousState){
    c.log('post.js:componentDidUpdate()');
    const { post, url } = this.props;
    if(post) {

      c.log(url)

      const categorySegment = url.query.category;
      const subCategorySegment = url.query.subCategory;
      const brandSegment = url.query.brand;

      if(post.sponsor) {
        DFPManager.setTargetingArguments({'brand': brandSegment })
      }
      else {
        DFPManager.setTargetingArguments({'section': categorySegment, 'sub-section': subCategorySegment });
      }

      DFPManager.configureLazyLoad(true);
      DFPManager.configureDisableInitialLoad(true);
      // ref: https://developers.google.com/publisher-tag/guides/control-ad-loading

      DFPManager.setCollapseEmptyDivs(true);

      if(!window.DFPManagerLoaded)
        DFPManager.load();
      else {
        // DFPManager.reload();
        // if(post.sponsor || post.category.sponsor) {
        //   DFPManager.reload();
        //   DFPManager.refresh();
        // }
      }
      // DFPManager.refresh();

      window.DFPManagerLoaded = true;

      if(!post.sponsor) {
        if(isMobile) {

          DFPManager.refresh([this.state.adMobileTop.id]);
          DFPManager.refresh([this.state.adMobileInlinePriorityOne.id]);
          DFPManager.refresh([this.state.adMobileInlinePriorityTwo.id]);
          DFPManager.refresh([this.state.adMobileMiddle.id]);
          DFPManager.refresh([this.state.adMobileBottom.id]);
          DFPManager.refresh(["teads_ad_1x1"]);

          // if (this.state.currentPageNumber == 1)
            // DFPManager.refresh([
            //   this.state.adMobileTop.id,
            //   this.state.adMobileInlinePriorityOne.id,
            //   this.state.adMobileInlinePriorityTwo.id,
            //   this.state.adMobileMiddle.id,
            //   this.state.adMobileBottom.id,
            //   "teads_ad_test"
            // ]);
        }
        else if (isBrowser) {
          DFPManager.refresh([this.state.adDesktopTop.id]);
          DFPManager.refresh([this.state.adDesktopInlinePriorityOne.id]);
          DFPManager.refresh([this.state.adDesktopInlinePriorityTwo.id]);
          DFPManager.refresh([this.state.adDesktopMiddle.id]);
          DFPManager.refresh([this.state.adMobileInlinePriorityOne.id]); // Sidebar Top rectangle
          if(post.category.sponsor)
            DFPManager.refresh([this.state.adBrandDesktopSidebar.id]);
          else
            DFPManager.refresh([this.state.adDesktopSidebar.id]);
          if(categorySegment == 'careers')
            DFPManager.refresh(["duwun_mobile_sidebar_priority_2"]); // Sidebar Bottom rectangle
          DFPManager.refresh([this.state.adDesktopBottom.id]);
          DFPManager.refresh(["teads_ad_1x1"]);
        }
      }
      else {
        DFPManager.refresh();
      }

      // DFPManager.refresh(["post-desktop-top"]);

      let { utm_source, utm_medium, utm_campaign, utm_term, utm_content} = url.query
      let utmUrl = utm_campaign || utm_term ||  utm_medium || utm_source || utm_content ;

      tagManagerArgs.dataLayer.CRMAuthor = post.author ? post.author.name + (post.co_authors && post.co_authors.length ? ',' + post.co_authors.map(e => e.name).join() : '') : 'Undefined';
      tagManagerArgs.dataLayer.CRMCreator = post.contributors && post.contributors.length ? post.contributors.map(e => e.name).join() : 'Undefined';      
      tagManagerArgs.dataLayer.Section = this.getDataLayerSection(post) || categorySegment
      tagManagerArgs.dataLayer.articlePublishedDate = post.published_date ? post.published_date.date : 'Undefined'

      if(utmUrl) {
        tagManagerArgs.dataLayer.utmCampaign = utm_campaign ? utm_campaign : 'Undefined'
        tagManagerArgs.dataLayer.utmContent = utm_content ? utm_content : 'Undefined'
        if(utm_medium)
          tagManagerArgs.dataLayer.utmMedium = utm_medium;
        if(utm_source)
          tagManagerArgs.dataLayer.utmSource = utm_source;
        tagManagerArgs.dataLayer.utmTerm = utm_term ? utm_term : 'Undefined'
      }

      if(post.campaign || isFacebookApp() ){
        if(!utmUrl){
          const defaultCampaign = url.query.subCategory === "cele-yatkwat" ? "cele-yatkwat-page-post" :
          url.query.category === "sport-news" ? "duwun-sports-page-post" :
          url.query.category === "tech" ? "duwun-tech-page-post" :
          url.query.category === "women" ? "madi-page-post" :
          url.query.category === "news" ? "duwun-page-post" :
          null;

          tagManagerArgs.dataLayer.utmCampaign = post.campaign && post.campaign.utm_campaign ? post.campaign.utm_campaign : defaultCampaign
          tagManagerArgs.dataLayer.utmContent = post.campaign && post.campaign.utm_content ? post.campaign.utm_content : 'Undefined'
          tagManagerArgs.dataLayer.utmMedium = post.campaign && post.campaign.utm_medium ? post.campaign.utm_medium : 'social'
          tagManagerArgs.dataLayer.utmSource = post.campaign && post.campaign.utm_source ? post.campaign.utm_source : 'facebook'
          tagManagerArgs.dataLayer.utmTerm = post.campaign && post.campaign.utm_term ? post.campaign.utm_term : 'Undefined'
        }
      }
      TagManager.dataLayer(tagManagerArgs);
      c.log('post.js:TagManager.dataLayer():Section:', tagManagerArgs.dataLayer.Section);
      // initCovidWidgets();
    }
  }

}

Post.propTypes = {
  classes: PropTypes.object.isRequired,
  post: PropTypes.shape({}),
  relatedPosts: PropTypes.arrayOf(PropTypes.object),

};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchPost,
      fetchRelatedPosts,
    },
    dispatch
  );

const mapStateToProps = state => ({
  post: state.posts.currentPost ? state.posts.currentPost.data || null : null,
  relatedPosts: state.posts.relatedPosts ? state.posts.relatedPosts.data || null : null,
  // links: state.posts.currentCategory.links,
  ads: state.posts.currentPost ? state.posts.currentPost.ads || null : null,
  inlineTeasers: state.posts.currentPost ? state.posts.currentPost.inline || null : null
});

export default withRedux(Store, mapStateToProps, mapDispatchToProps)(
  withReduxSaga(withStyles(styles)(Post))
);
